/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Contract, Signer, utils } from "ethers";
import { Provider } from "@ethersproject/providers";
import type {
  ERC20Bytes32Symbol,
  ERC20Bytes32SymbolInterface,
} from "../ERC20Bytes32Symbol";

const _abi = [
  {
    inputs: [],
    name: "symbol",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
];

export class ERC20Bytes32Symbol__factory {
  static readonly abi = _abi;
  static createInterface(): ERC20Bytes32SymbolInterface {
    return new utils.Interface(_abi) as ERC20Bytes32SymbolInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): ERC20Bytes32Symbol {
    return new Contract(address, _abi, signerOrProvider) as ERC20Bytes32Symbol;
  }
}
